import { convertListValueLabel } from "../../utils/convert-select-value";
import { isArrayWithLength } from "../../utils/array-methods";

const mapInsightParameters = (parameters, selectedInsight) => {
  return (
    isArrayWithLength(parameters) &&
    parameters.map((param) => {
      let updatedParam = { ...param };
      if (
        param.parameterKey === "InstanceId" &&
        selectedInsight.insight.resourceType === "AwsEc2Instance"
      ) {
        const resourceARN = selectedInsight.insight.resourceId;
        if (resourceARN) {
          const instanceId = resourceARN.split("instance/")[1];
          if (instanceId) {
            updatedParam = {
              ...updatedParam,
              parameterValue: instanceId,
            };
          }
        }
      }
      return updatedParam;
    })
  );
};

export const getUpdatedParams = (processedParams, task, selectedInsight) => {
  const { selectedTask, taskParameters } = task;
  let updatedParameters = processedParams.map((param) => {
    const foundTaskParameter =
      taskParameters &&
      taskParameters.find((t) => t.ParameterKey === param.parameterKey);
    if (foundTaskParameter) {
      return {
        ...param,
        parameterValue:
          param.parameterType === "List"
            ? convertListValueLabel(foundTaskParameter.ParameterValue)
            : foundTaskParameter.ParameterValue,
      };
    }
    return param;
  });
  if (selectedInsight && selectedTask && selectedTask.isRecommendedTask) {
    updatedParameters = mapInsightParameters(
      updatedParameters,
      selectedInsight
    );
  }
  return updatedParameters;
};
